export default "__VITE_ASSET__D_7L67ux__"